import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import feedbackTheme from "../../theme/feedback";

const baseOptions = {
  position: feedbackTheme.toast.position,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const optionsFor = (type, overrideTime) => ({
  ...baseOptions,
  autoClose:
    overrideTime !== undefined
      ? overrideTime
      : feedbackTheme.toast.autoClose[type] ?? 5000,
});

const notifySuccess = (message, time) => toast.success(message, optionsFor("success", time));
const notifyInfo = (message, time) => toast.info(message, optionsFor("info", time));
const notifyWarning = (message, time) => toast.warn(message, optionsFor("warning", time));
const notifyError = (message, time) => toast.error(message, optionsFor("error", time));

const Notify = (message = "this notification required a message", type, time) => {
  switch (type) {
    case "info":
      return notifyInfo(message, time);
    case "success":
      return notifySuccess(message, time);
    case "warning":
      return notifyWarning(message, time);
    case "error":
      return notifyError(message, time);
    default:
      return toast(message, optionsFor("info", time));
  }
};

Notify.success = notifySuccess;
Notify.info = notifyInfo;
Notify.warning = notifyWarning;
Notify.error = notifyError;

export { notifySuccess, notifyInfo, notifyWarning, notifyError };
export default Notify;
